import client from './client';

export type TwilioCategoryKey = 'sms' | 'whatsapp' | 'verify' | 'other';
export type TwilioChannel = 'sms' | 'whatsapp' | 'other';
export type TwilioChannelFilter = 'sms' | 'whatsapp' | 'all';

export interface TwilioStatsResponse {
  balance: { amount: number; currency: string } | null;
  range: { startDate: string; endDate: string };
  costs: {
    sms: number;
    whatsapp: number;
    verify: number;
    other: number;
    total: number;
  };
  counts: {
    sms: number;
    whatsapp: number;
    verify: number;
  };
  byCategory: Array<{ category: string; price: number; count: number; key: TwilioCategoryKey }>;
  currency: string;
}

export interface TwilioMessageRow {
  sid: string;
  to: string;
  from: string;
  body: string;
  status: string;
  direction: string;
  channel: TwilioChannel;
  price: number | null;
  priceUnit: string | null;
  dateSent: string | null;
  errorCode: number | null;
  errorMessage: string | null;
}

export interface TwilioMessageListResponse {
  messages: TwilioMessageRow[];
  nextPageToken: string | null;
}

export interface TwilioUnmaskResponse {
  sid: string;
  to: string;
  from: string;
}

export const twilioApi = {
  getStats: (params: { startDate: string; endDate: string }) =>
    client
      .get<TwilioStatsResponse>('/admin/twilio/stats', { params })
      .then((r) => r.data),

  getMessages: (params: {
    startDate: string;
    endDate: string;
    channel?: TwilioChannelFilter;
    limit?: number;
    pageToken?: string | null;
  }) =>
    client
      .get<TwilioMessageListResponse>('/admin/twilio/messages', {
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          channel: params.channel ?? 'all',
          limit: params.limit ?? 50,
          ...(params.pageToken ? { pageToken: params.pageToken } : {}),
        },
      })
      .then((r) => r.data),

  unmaskMessage: (sid: string) =>
    client
      .get<TwilioUnmaskResponse>(`/admin/twilio/messages/${sid}/unmask`)
      .then((r) => r.data),
};
